import React from 'react';
import { Button, Modal } from 'react-bootstrap';

export default function ApproveMilestoneModal({ show, onClose, onConfirm, onReject, loading }) {
  return (
    <Modal show={show} centered size="lg" onHide={onClose}>
      <Modal.Header closeButton>
        Автоматическая публикация новости
      </Modal.Header>

      <Modal.Body>
        <p><strong>Факт достижения по вехе будет опубликован в разделе "Новости".</strong></p>
        <p>Открыть окно для редактирования новости перед публикацией?</p>
      </Modal.Body>

      <Modal.Footer>
        <Button onClick={onClose} disabled={loading} variant="outline-secondary">Отмена</Button>
        <Button onClick={!loading ? onReject : null} disabled={loading} variant="outline-secondary">Нет</Button>
        <Button onClick={!loading ? onConfirm : null} disabled={loading} variant="primary">Да</Button>
      </Modal.Footer>
    </Modal>
  );
}
